import { css } from '@emotion/react'
import { Branding } from '../types'
import {
  primaryContrastDefault,
  primaryDefault,
  secondaryContrastDefault,
  secondaryDefault,
} from './Stories.utils'

export const summaryPageContainer = (branding: Branding | undefined) => css`
  display: flex;
  flex-flow: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: ${branding?.primaryContrast ?? primaryContrastDefault};
  background-color: ${branding?.primary ?? primaryDefault};
`

export const backButton = (branding: Branding | undefined) => css`
  border-color: ${branding?.primaryContrast ?? primaryContrastDefault};
  color: ${branding?.primaryContrast ?? primaryContrastDefault};
  background-color: ${branding?.primary ?? primaryDefault};
  margin: 32px 11px;
  padding: 5px 15px;
  &:hover {
    background-color: ${branding?.primaryContrast ?? primaryContrastDefault};
    color: ${branding?.primary ?? primaryDefault};
  }
`

export const nextButton = (branding: Branding | undefined) => css`
  color: ${branding?.secondaryContrast ?? secondaryContrastDefault};
  background-color: ${branding?.secondary ?? secondaryDefault};
  margin: 32px 11px;
  padding: 5px 15px;
  &:hover {
    background-color: ${branding?.primaryContrast ?? primaryContrastDefault};
    color: ${branding?.primary ?? primaryDefault};
  }
`

export const summaryPageContent = (branding: Branding | undefined) => css`
  max-width: 1240px;
  max-height: 862px;
  padding: 60px;
  background-color: #fff;
  border-radius: 10px;
  color: #000;
  h1 {
    color: ${branding?.primary ?? primaryDefault};
  }
`

export const summaryPageCopy = css`
  max-height: 362px;
  overflow: auto;
`

export const theLogos = css`
  display: flex;
  flex-direction: row;
  justify-content: justified;
  align-items: end;
  width: 100%;
  max-width: 1240px;
  margin-bottom: 21px;

  .theClientLogo {
    height: 44.877px;
    margin-bottom: 17px;
  }
  .genXLogo {
    height: 104.126px;
  }
`

export const buttons = css`
  display: flex;
  flex-direction: row;
  justify-content: right;
  width: 100%;
  max-width: 1240px;
`
